type Props = {
  cashbackValue: string
}

const CartFeedbackCashback = ({ cashbackValue }: Props) => {
  return (
    <div
      className="relative mt-1 flex h-[51px] items-center justify-center overflow-hidden rounded-[4px] bg-[#00915C] px-3"
      data-testid="cart-feedback-cashback"
    >
      <p className="text-xs font-semibold leading-[normal] text-white">
        Você já tem{' '}
        <span className="font-bold">{cashbackValue} de cashback </span>
        no carrinho! <br />
        Continue comprando para ganhar mais
      </p>
    </div>
  )
}

export default CartFeedbackCashback
